import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap"; // Correct imports

const Contact = () => {
  return (
    <Container
      fluid
      className="p-5"
      style={{ backgroundColor: "#f7f9fc", fontFamily: "'Baloo Bhaijaan 2'" }}
    >
      <Row className="justify-content-center">
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.10.5/font/bootstrap-icons.min.css"
        />
        <Col
          md={10}
          className="rounded shadow-sm p-4"
          style={{ backgroundColor: "#f3f4f6" }}
        >
          <Row className="mb-4">
            <Col xs={12} className="text-center">
              <h2 className="mb-3">تواصل معنا</h2>
            </Col>
          </Row>

          <Row>
            <Col
              md={6}
              className="text-center d-flex flex-column justify-content-center"
            >
              <h3
                className="mb-3"
                style={{ textAlign: "right", paddingBottom: "15px" }}
              >
                معلومات عن الموقع
              </h3>
              <p
                style={{ textAlign: "right", fontSize: "18px" }}
                className="text-gray-600"
              >
                مرحبًا بكم في &quot;طلب&quot;، متجركم المفضل للتسوق الإلكتروني
                في العالم العربي. نحن نقدم تجربة تسوق سلسة وآمنة تجمع بين
                الزبائن والمتسوقين في مكان واحد.
              </p>
              <p style={{ textAlign: "right", fontSize: "18px" }}>
                مع &quot;طلب&quot;، يمكنك الوصول إلى مجموعة واسعة من المنتجات،
                من الإلكترونيات إلى الأزياء، ومن مستلزمات المنزل إلى الهدايا
                الفريدة. نحن نضمن جودة المنتجات وسرعة التوصيل لتوفر لكم أفضل
                تجربة تسوق ممكنة.
              </p>
              <div className="d-flex" style={{ paddingTop: "30px" }}>
                <a
                  href="https://www.facebook.com/aitlub1"
                  target="_blank"
                  className="mx-2 text-dark"
                >
                  <i
                    className="bi bi-facebook"
                    style={{ fontSize: "22px" }}
                  ></i>
                </a>
                <a
                  href="https://www.youtube.com/aitlub1"
                  target="_blank"
                  className="mx-2 text-dark"
                >
                  <i
                    className="bi bi-instagram"
                    style={{ fontSize: "25px" }}
                  ></i>
                </a>
                <a
                  href="https://www.tiktok.com/@aitlub1"
                  target="_blank"
                  className="mx-2 text-dark"
                >
                  <i className="bi bi-tiktok" style={{ fontSize: "25px" }}></i>
                </a>
              </div>
            </Col>

            <Col
              md={6}
              className="bg-gradient rounded p-4"
              style={{ background: "#4f46e5" }}
            >
              <h4 className="text-white mb-4 text-right">تواصل معنا</h4>
              <Form>
                <Form.Group className="mb-3">
                  {/* <Form.Label className="text-white">الاسم</Form.Label> */}
                  <Form.Control
                    type="text"
                    placeholder="أدخل اسمك"
                    className="form-control"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  {/* <Form.Label className="text-white">رقم الهاتف</Form.Label> */}
                  <Form.Control
                    type="text"
                    placeholder="أدخل رقم الهاتف"
                    className="form-control"
                  />
                </Form.Group>
                <Button variant="light" type="submit" className="w-100">
                  إرسال
                </Button>
              </Form>
            </Col>
          </Row>

          <Row style={{ marginTop: "60px" }}>
            <Col>
              <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31593.16909536968!2d32.56756959341655!3d0.3136151125154978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbc0f3464d36b%3A0xa292a1708d120c12!2sKampala!5e0!3m2!1sen!2sug!4v1687791851527!5m2!1sen!2sug"
                width="100%"
                height="400"
                style={{ border: "0" }}
                allowFullScreen={true}
                loading="lazy"
              ></iframe>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
